import { render, staticRenderFns } from "./StepsNav.vue?vue&type=template&id=0cc208e6"
import script from "./StepsNav.vue?vue&type=script&lang=js"
export * from "./StepsNav.vue?vue&type=script&lang=js"
import style0 from "./StepsNav.vue?vue&type=style&index=0&id=0cc208e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports